// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/set-user-app-role-request-schema',
  type: 'object',
  required: ['id', 'newRoleId'],
  properties: {
    id: {
      type: 'integer',
    },
    newRoleId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
